<template>
    <!-- eslint-disable max-len,vue/no-v-html -->
    <div>
        <ul
            v-if="devise.showCategories.checked"
            class="flex justify-start md:justify-center flex-wrap items-stretch py-8"
        >
            <li class="mx-4 my-1 md:my-4">
                <a
                    href="#"
                    v-bind:class="btnClasses('all')"
                    @click.prevent="loadCategory('all')"
                >
                    All
                </a>
            </li>
            <li
                v-for="(category, key) in categories"
                :key="key"
                class="mx-4 my-1 md:my-4"
            >
                <a
                    href="#"
                    v-bind:class="btnClasses(key)"
                    @click.prevent="loadCategory(key)"
                >
                    {{ category }}
                </a>
            </li>
        </ul>

        <div
            class="transition duration-2000"
            :class="{ 'opacity-0': !isLoaded, 'opacity-100': isLoaded }"
        >
            <div
                class="gallery"
                :class="{
                    'shift-gallery': currentlySelectedSlice.show,
                }"
            >
                <div class="grid-spacer w-full md:w-1/4 h-96" />
                <slices
                    class="grid-item"
                    :slices="slices"
                    @loadSidebar="loadSidebar"
                    @loadZoom="loadZoom"
                    :loaded="isLoaded"
                />
            </div>
        </div>

        <!-- Blocker -->
        <transition name="fast-fade">
            <div
                v-if="
                    currentlySelectedSlice.show || currentlySelectedImage.show
                "
                class="fixed inset-0 opacity-75 bg-sanctuary-action z-100"
                @click="unloadAll"
            />
        </transition>

        <!-- Sidebar slideout dude -->
        <transition name="grid-slide">
            <div
                v-if="currentlySelectedSlice.show"
                class="fixed top-0 bottom-0 right-0 w-full md:w-3/5 z-100 bg-grey-light overflow-scroll"
            >
                <img :src="currentlySelectedSlice.largeImage" class="w-full" />
                <div
                    class="cursor-pointer bg-sanctuary-bright-blue text-center rounded-full p-4 text-white text-5xl flex align-center justify-center font-extrabold font-sans absolute top-0 right-0 z-20 mr-12 mt-8"
                    style="width: 90px; height: 90px"
                    @click="unloadSidebar"
                >
                    ✖
                </div>
                <div class="p-8 md:p-12">
                    <h2 class="text-center text-grey-darkest text-4xl mb-8">
                        {{ currentlySelectedSlice.title }}
                    </h2>
                    <div
                        class="text-grey-darkest"
                        v-html="currentlySelectedSlice.content"
                    />
                </div>
            </div>
        </transition>

        <!-- Image Zoom -->
        <transition name="fade">
            <div
                v-if="currentlySelectedImage.show"
                class="fixed absolute-center w-4/5 z-100 flex flex-col item-center justify-center max-w-full max-h-full"
            >
                <h2
                    v-if="
                        currentlySelectedImage.image.alt &&
                        currentlySelectedImage.image.alt !== ''
                    "
                    class="text-abs-white mb-4 p-4 rounded"
                    style="background-color: rgba(0, 0, 0, 0.5)"
                >
                    {{ currentlySelectedImage.image.alt }}
                </h2>
                <div class="flex justify-center">
                    <div class="relative">
                        <img :src="currentlySelectedImage.image.media.zoom" />
                        <div
                            class="cursor-pointer text-center rounded-full p-6 flex items-center justify-center absolute top-0 right-0 z-20 bg-black -mt-6 -mr-6"
                            style="width: 50px; height: 50px"
                            @click="unloadZoom"
                        >
                            <div
                                class="text-white text-2xl flex items-center justify-center font-extrabold font-sans"
                            >
                                ✖
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Shuffle from 'shufflejs';

const imagesLoaded = require('imagesloaded');

export default {
    name: 'GridGallery',
    props: {
        slices: {
            type: Array,
            required: true,
        },
        columnWidth: {
            type: Number,
            default: 200,
        },
        categories: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            isLoaded: false,
            shuffle: null,
            currentlySelectedSlice: {
                content: null,
                largeImage: null,
                title: null,
                show: false,
            },
            currentlySelectedImage: {
                image: null,
                show: false,
            },
            currentCategory: 'all',
        };
    },
    mounted() {
        this.shuffle = new Shuffle(
            this.$el.getElementsByClassName('gallery')[0],
            {
                itemSelector: '.grid-item',
                sizer: '.grid-spacer',
                gutter: 0,
                percntPosition: true,
            }
        );

        this.shuffle.layout();
        imagesLoaded(this.$el, { background: true }, () => {
            this.shuffle.layout();
            this.isLoaded = true;
        });
    },
    methods: {
        loadSidebar(data) {
            this.currentlySelectedSlice.title = data.title.text;
            this.currentlySelectedSlice.content = data.content.text;
            this.currentlySelectedSlice.largeImage = data.largeImage.url;
            this.currentlySelectedSlice.show = true;
        },
        unloadAll() {
            this.unloadSidebar();
            this.unloadZoom();
        },
        unloadSidebar() {
            this.currentlySelectedSlice.show = false;
        },
        loadZoom(image) {
            if (this.breakpoint !== 'mobile') {
                this.currentlySelectedImage.image = image;
                this.currentlySelectedImage.show = true;
            }
        },
        unloadZoom() {
            this.currentlySelectedImage.show = false;
        },
        loadCategory(category) {
            this.currentCategory = category;
            if (category === 'all') {
                this.shuffle.filter();
            } else {
                this.shuffle.filter(category);
            }
        },
        btnClasses(key) {
            if (this.currentPage.site_id == 12) {
                if (this.currentCategory == key) {
                    return 'bg-collection-teal text-white py-4 px-6 border-grey-light border-2 inline-block';
                } else {
                    return 'bg-white py-4 px-6 text-grey-dark border-grey-light border-2 inline-block';
                }
            }
            if (this.currentPage.site_id != 12) {
                if (this.currentCategory == key) {
                    return 'btn btn-primary btn-sm rounded-sm';
                } else {
                    return 'btn btn-ghost btn-sm rounded-sm';
                }
            }
        },
    },
};
</script>
